import React, { useState } from 'react'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import EmojiPicker from 'srcReact/components/common2/EmojiPicker'
import { useTranslation } from 'react-i18next'

export default function MessageActions({
  isActiveConvoUser,
  isLoggedInUser,
  editMessage,
  deleteMessagePopin,
  copyMessage,
  replyMessage,
  appendEmoji,
  handleOpenPicker,
  isEmojiPickerOpen
}) {
  const { t } = useTranslation()
  const contentStyle = {
    background: colorVariables.darkGray,
    color: colorVariables.whiteColor,
    maxWidth: '11rem',
    height: '2rem',
    marginBottom: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
  const [isOpen, setIsOpen] = useState(false)

  return (
    isActiveConvoUser && (
      <div className={styles.messageActionsContainer}>
        <div className={styles.messageActions}>
          <button type='button' className={`${styles.buttonAction}`}>
            <EmojiPicker
              iconName='add-reaction'
              iconStyle={styles.gladIcon}
              appendEmoji={appendEmoji}
              handleOpenPicker={handleOpenPicker}
              pickerContainerCSS={styles.emojiPickerContainerCSS}
              containerCss={styles.emojiContainerCSS}
              emojiButtonCSS={styles.emojiButtonCSS}
            />
          </button>
          <span>{t('messenger.react')}</span>
        </div>
        <div className={styles.messageActions}>
          <button type='button' onClick={replyMessage} className={styles.buttonAction}>
            <Icon name='reply' />
          </button>
          <span>{t('messenger.reply')}</span>
        </div>
        {isLoggedInUser && (
          <div className={styles.messageActions}>
            <button type='button' onClick={editMessage} className={styles.buttonAction}>
              <Icon name='edit' />
            </button>
            <span>{t('global.edit')}</span>
          </div>
        )}
        <div className={styles.messageActions}>
          <button type='button' onClick={copyMessage} className={`${styles.buttonAction} ${styles.copyIcon}`}>
            <Icon name='copy' />
          </button>
          <span>{t('messenger.copy')}</span>
        </div>
        {isLoggedInUser && (
          <div className={styles.messageActions}>
            <button type='button' onClick={deleteMessagePopin} className={styles.buttonAction}>
              <Icon name='delete' />
            </button>
            <span>{t('messenger.delete')}</span>
          </div>
        )}
      </div>
    )
  )
}
